import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "d-flex align-center justify-space-between ga-6 flex-wrap" }

import {ref, watch, onMounted, inject} from 'vue';
import {cartService} from "@/api/services/cart";
import Icon from "@/components/Icons/Icon.vue";
import {useSettingsStore} from "@/api/store/settings";


export default /*@__PURE__*/_defineComponent({
  __name: 'ShopCartAddShippingMethodModal',
  props: {
  modelValue: [String, Number],
  cartId: {
    type: [String, Number],
  },
  shippingId: {
    type: [String, Number],
  }
},
  emits: ['update:modelValue', 'addShipping'],
  setup(__props, { emit: __emit }) {

const emit = __emit;
const settingsStore = useSettingsStore();

const props = __props;

const snackBarPlugin = inject('snackbar');

const dialog = ref(props.modelValue);
const shippingMethods = ref([]);
const selectedShippingMethod = ref(null);

const onAddShippingMethod = () => {
  cartService.addItem(props.cartId, selectedShippingMethod.value, 1).then(() => {
    dialog.value = false;
    emit('addShipping');
    snackBarPlugin?.successSnackbar('Shipping method added successfully');
  }).catch((error: any) => {
    console.log(error);
  });
}

const getShippingMethod = () => {
  
  cartService.getShippingMethod(props.cartId, props.shippingId).then((resp) => {
    shippingMethods.value = resp.shipping_methods;
    
  }).catch((error: any) => {
    console.log(error);
  });
};

watch(dialog, (newValue) => {
  emit('update:modelValue', newValue);
});

onMounted(getShippingMethod);

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: dialog.value,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((dialog).value = $event)),
    "max-width": "300",
    "min-width": "270",
    persistent: ""
  }, {
    default: _withCtx(() => [
      (_unref(settingsStore).loading === false)
        ? (_openBlock(), _createBlock(_component_v_card, {
            key: 0,
            "max-height": "250",
            "min-height": "350"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, { class: "text-h6 d-flex justify-space-between align-center" }, {
                default: _withCtx(() => [
                  _cache[4] || (_cache[4] = _createTextVNode(" Add Shipping Method ", -1)),
                  _createElementVNode("div", {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (dialog.value = false))
                  }, [
                    _createVNode(Icon, {
                      color: "grey_light",
                      icon: "cross-icon"
                    })
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_v_divider),
              (shippingMethods.value.length > 0)
                ? (_openBlock(), _createBlock(_component_v_card_text, { key: 0 }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shippingMethods.value, (method, index) => {
                        return (_openBlock(), _createBlock(_component_v_radio_group, {
                          key: `method-${index}`,
                          modelValue: selectedShippingMethod.value,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedShippingMethod).value = $event)),
                          class: "w-100"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_radio, {
                              value: method.id,
                              color: "success"
                            }, {
                              label: _withCtx(() => [
                                _createElementVNode("div", _hoisted_1, [
                                  _createElementVNode("p", null, _toDisplayString(method.name), 1),
                                  _createElementVNode("p", null, _toDisplayString(method.price_display), 1)
                                ])
                              ]),
                              _: 2
                            }, 1032, ["value"])
                          ]),
                          _: 2
                        }, 1032, ["modelValue"]))
                      }), 128))
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_v_card_text, {
                    key: 1,
                    class: "d-flex align-center"
                  }, {
                    default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                      _createElementVNode("p", { class: "text-center" }, "No shipping methods available", -1)
                    ]))]),
                    _: 1
                  })),
              _createVNode(_component_v_divider),
              _createVNode(_component_v_card_actions, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_spacer),
                  _createVNode(_component_v_btn, {
                    class: "b-round-20 outline-btn cancel",
                    elevation: "0",
                    height: "32px",
                    "x-small": "",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (dialog.value = false))
                  }, {
                    default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                      _createTextVNode(" Cancel ", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_v_btn, {
                    disabled: selectedShippingMethod.value === null,
                    class: "text-white b-round-20 outline-btn white-btn",
                    elevation: "0",
                    height: "32px",
                    "x-small": "",
                    onClick: onAddShippingMethod
                  }, {
                    default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                      _createTextVNode(" Confirm ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})